import { Document, Page, Text, View } from '@react-pdf/renderer';
import { format } from 'date-fns';
import { reportStyles } from './ReportPage.Style';

interface MovimentacaoTipoPDFProps {
  registros: {
    objects: Array<{
      descricao: string;
      inicial: boolean;
      ehNucleo: boolean;
    }>;
    count: number;
  };
}

export const MovimentacaoTipoPDF = ({ registros }: MovimentacaoTipoPDFProps) => (
  <Document>
    <Page size="A4" style={reportStyles.page}>
      <Text style={reportStyles.header}>
        Tipos de Movimentações Cadastrados no Sistema
      </Text>
      <View style={reportStyles.table}>
        <View style={reportStyles.tableRow}>
          <View style={reportStyles.tableFirstColHeader}>
            <Text style={reportStyles.headerText}>Descrição</Text>
          </View>
          <View style={reportStyles.tableColHeader}>
            <Text style={reportStyles.headerText}>Inicial</Text>
          </View>
          <View style={reportStyles.tableColHeader}>
            <Text style={reportStyles.headerText}>Tipo</Text>
          </View>
        </View>
        {(Array.isArray(registros?.objects) ? registros.objects : []).map((item: any, index: number) => (
          <View key={index} style={reportStyles.tableRow}>
            <View style={reportStyles.tableFirstCol}>
              <Text>{item.descricao}</Text>
            </View>
            <View style={reportStyles.tableCol}>
              <Text>{item.inicial ? 'Sim' : 'Não'}</Text>
            </View>
            <View style={reportStyles.tableCol}>
              <Text>{item.ehNucleo ? 'N' : 'D'}</Text>
            </View>
          </View>
        ))}
      </View>
      <Text style={reportStyles.legendText}>
        Tipos: D = Defensoria | N = Núcleo
      </Text>
      <Text style={reportStyles.footer}>
        Gerado em {format(new Date(), 'dd/MM/yyyy HH:MM')} | {registros.count} registros.
      </Text>
    </Page>
  </Document>
);